import $ from 'jquery'
import '@/jsUtils/plugins/bootstrap4.0.0/bootstrap5.0.2.min.css';
import '@/jsUtils/plugins/bootstrap4.0.0/bootstrap5.0.2.min.js';
// import '../node_modules/bootstrap/dist/js/bootstrap.min.js'


import App from './App.vue'
import '@/assets/public/css/global.css'

import { createApp, VueElement } from 'vue'  ;
import router from "./router" ;
import i18n from './lang';
import { createPinia } from 'pinia';

// import vueInfiniteScroll from 'vue-infinite-scroll';


import 'element-plus/theme-chalk/index.css';
import ElementPlus from 'element-plus';       


const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(i18n);
app.use(ElementPlus);
app.use(pinia);

// app.use(vueInfiniteScroll);

app.mount('#app');

VueElement.prototype.testValue=121;

